import { ReactNode, useEffect } from 'react';
import { BottomNavigation } from './BottomNavigation';
import { TopBar } from './TopBar';
import { useToastStore } from '../../store/toastStore';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { message, type, hide } = useToastStore();

  // Автоматически скрываем через 10 секунд
  useEffect(() => {
    if (message) {
      const timer = setTimeout(hide, 10000);
      return () => clearTimeout(timer);
    }
  }, [message, hide]);

  return (
    <div className="min-h-screen theme-layout">
      <TopBar />

      {/* Global Toast */}
      {message && (
        <div className="fixed top-16 left-0 right-0 z-50 px-4">
          <div className={`mx-auto max-w-md p-4 rounded-lg shadow-lg ${
            type === 'error' ? 'bg-red-500 text-white' :
            type === 'success' ? 'bg-green-500 text-white' :
            'bg-blue-500 text-white'
          }`}>
            <div className="flex items-start justify-between">
              <p className="text-sm font-medium flex-1">{message}</p>
              <button onClick={hide} className="ml-3 text-white/80 hover:text-white">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

      <main className="pb-20 pt-20">
        <div className="container mx-auto px-4">
          {children}
        </div>
      </main>

      <BottomNavigation />
    </div>
  );
}